import styled,{keyframes} from "styled-components";


export const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
`;

export const float = keyframes`
  0% { transform: translateY(0px); }
  50% { transform: translateY(-15px); }
  100% { transform: translateY(0px); }
`;

export const Title = styled.h2`
  font-size: 2.5rem;
  font-weight: 700;
  color: #333;
  margin-bottom: 0.5rem;
`;



export const gradientShift = keyframes`
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
`;

export const Container = styled.div`
  display: flex;
  min-height: 130vh;
  background: #fafafa;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const SuccessMessage = styled.div`
  color: #4BB543;
  margin-bottom: 1rem;
  padding: 0.5rem;
  background-color: #f0fff0;
  border-radius: 4px;
  border-left: 4px solid #4BB543;
  font-size:1.2rem;
`;

export const VisualPanel = styled.div`
  flex: 1;
  background: linear-gradient(-45deg, #8b0000, #a52a2a, #8b0000, #a52a2a);
  background-size: 400% 400%;
  animation: ${gradientShift} 12s ease infinite;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  margin-top: 0rem;
  position: relative;
  overflow: hidden;
  color: #fff;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const AuthPanel = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 6rem;
  background: #ffffff;

  @media (max-width: 768px) {
    padding: 1.5rem;
    width: 100%;
    height: 100vh;
  }
`;

export const AuthCard = styled.div`
  width: 100%;
  max-width: 500px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.05);
  border: 5px solid rgba(0, 0, 0, 0.05);
  padding: 2.5rem;
  animation: ${fadeIn} 0.6s ease-out;

  @media (max-width: 768px) {
    padding: 1.5rem;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  }
`;

export const BrandContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 3rem;
  z-index: 2;
${'' /* item at the left end */}
  position: absolute;
  top: 7px;
  left: 20px;

`;

export const LogoImage = styled.img`
  width: 130px;
  height: 48px;
  margin-right: 6px;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
`;

export const BrandText = styled.div`
  color: #fff;
  font-weight: 700;
  font-size: 1.8rem;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
`;

export const VisualContent = styled.div`
  position: relative;
  z-index: 2;
  text-align: center;
  color: #fff;
  max-width: 500px;
`;

export const MainHeading = styled.h2`
  font-size: 3.1rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  line-height: 1.2;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  color: #fff;
`;

export const SubHeading = styled.p`
  font-size: 1.4rem;
  opacity: 0.9;
  line-height: 1.6;
  margin-bottom: 2rem;
  color: rgba(255, 255, 255, 0.9);
`;

export const FeatureList = styled.div`
  text-align: left;
  margin-top: 2.3rem;
`;

export const FeatureItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  font-size: 1.3rem;
  color: rgba(255, 255, 255, 0.9);
`;

export const FeatureIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  margin-right: 12px;
  padding: 5px;
  color: #fff;
`;

export const FloatingShapes = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  overflow: hidden;
  z-index: 1;
`;

export const Circle = styled.div`
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  animation: ${float} 8s ease-in-out infinite;
`;

export const Triangle = styled.div`
  position: absolute;
  width: 0;
  height: 0;
  border-left: 50px solid transparent;
  border-right: 50px solid transparent;
  border-bottom: 100px solid rgba(255, 255, 255, 0.1);
  animation: ${float} 10s ease-in-out infinite;
`;



export const InputContainer = styled.div`
  margin-bottom: 1.5rem;
  position: relative;
`;

export const InputLabel = styled.label`
  display: block;
  margin-bottom: 0.5rem;
  font-size: 1.3rem;
  color: #555;
  font-weight: 500;
`;

export const InputField = styled.input`
  width: 100%;
  padding: 0.8rem 1rem;
  box-sizing: border-box;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-size: 1.1rem;
  transition: all 0.3s ease;

  &:focus {
    border-color: #8b0000;
    box-shadow: 0 0 0 3px rgba(139, 0, 0, 0.1);
    outline: none;
  }
`;

export const SubmitButton = styled.button`
  width: 100%;
  padding: 1rem;
  background: #e32636;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1.2rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 1rem;

  &:hover {
    background: #b22222;
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    background: #e0e0e0;
    cursor: not-allowed;
    transform: none;
  }
`;

export const OTPInputsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 2rem;
  gap: 10px;
`;

export const ErrorMessage = styled.div`
  color: #8b0000;
  background: rgba(139, 0, 0, 0.05);
  padding: 0.8rem;
  border-radius: 8px;
  margin-bottom: 1rem;
  font-size: 1.2rem;
  border-left: 3px solid #8b0000;
  animation: ${fadeIn} 0.3s ease-out;
`;

export const FooterLinks = styled.div`
  margin-top: 1.5rem;
  text-align: center;
  font-size: 1rem;
`;

export const Link = styled.a`
  color: #8b0000;
  text-decoration: none;
  font-weight: 500;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;



// login otp screen




// Styled Components for OTP Screen
export const OtpContainer = styled.div`
  animation: ${fadeIn} 0.6s ease-out;
`;

export const OtpTitle = styled.h1`
  font-size: 2.2rem;
  font-weight: 700;
  color: #333;
  margin-bottom: 0.5rem;
`;

export const OtpSubtitle = styled.p`
  color: #666;
  margin-bottom: 2rem;
  font-size: 1.1rem;
`;

export const OtpSentTo = styled.div`
  background: rgba(139, 0, 0, 0.05);
  padding: 0.8rem;
  border-radius: 8px;
  margin-bottom: 1.5rem;
  font-size: 1.1rem;
  border-left: 3px solid #8b0000;
`;

export const OtpInputsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 2rem;
  gap: 10px;
`;

export const OtpInput = styled.input`
  width: 100%;
  height: 60px;
  text-align: center;
  font-size: 1.6rem;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  transition: all 0.3s ease;

  &:focus {
    border-color: #8b0000;
    box-shadow: 0 0 0 3px rgba(139, 0, 0, 0.1);
    outline: none;
  }

  @media (max-width: 480px) {
    height: 50px;
    font-size: 1.2rem;
  }
`;

export const OtpActionButton = styled.button`
  width: 100%;
  padding: 1rem;
  background: red;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1.2rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 1rem;

  &:hover {
    background: #6b0000;
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    background: #e0e0e0;
    cursor: not-allowed;
    transform: none;
    color: #999;
  }
`;

export const OtpFooter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 1.5rem;
  font-size: 1.1rem;
`;

export const OtpResendText = styled.span`
  color: #666;
  margin-right: 0.5rem;
`;

export const OtpResendButton = styled.button`
  background: none;
  border: none;
  color: #8b0000;
  font-weight: 500;
  cursor: pointer;
  padding: 0;
  font-size: 1.1rem;

  &:hover {
    text-decoration: underline;
  }

  &:disabled {
    color: #999;
    cursor: not-allowed;
    text-decoration: none;
  }
`;

export const OtpBackButton = styled.button`
  background: none;
  border: none;
  color: #8b0000;
  font-weight: 500;
  cursor: pointer;
  padding: 0;
  margin-top: 1.5rem;
  font-size: 1.1rem;
  display: flex;
  align-items: center;
  gap: 5px;
  margin-left: auto;
  margin-right: auto;

  &:hover {
    text-decoration: underline;
  }
`;

export const OtpError = styled.div`
  color: #8b0000;
  background: rgba(139, 0, 0, 0.05);
  padding: 0.8rem;
  border-radius: 8px;
  margin-bottom: 1rem;
  font-size: 1.1rem;
  border-left: 3px solid #8b0000;
  animation: ${fadeIn} 0.3s ease-out;
`;

export const OtpSuccess = styled.div`
  color: #2e7d32;
  background: rgba(46, 125, 50, 0.05);
  padding: 0.8rem;
  border-radius: 8px;
  margin-bottom: 1rem;
  font-size: 1.1rem;
  border-left: 3px solid #2e7d32;
  animation: ${fadeIn} 0.3s ease-out;
`;

export const OtpTimer = styled.span`
  color: #8b0000;
  font-weight: 600;
`;

// Styled Components for Password Reset Form
export const FormCard = styled.div`
  background: white;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  animation: ${fadeIn} 0.6s ease-out;
  margin-top: 1.5rem;
`;



export const Subtitle = styled.p`
  color: #666;
  margin-bottom: 1.5rem;
  font-size: 1.3rem;
  line-height: 1.6;
  font-family: 'Calibri';
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const Label = styled.label`
  font-size: 1.1rem;
  color: #555;
  font-weight: 500;
`;

export const Input = styled.input`
  padding: 0.8rem;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-size: 1.2rem;
  transition: all 0.3s ease;

  &:focus {
    border-color: #8b0000;
    box-shadow: 0 0 0 3px rgba(139, 0, 0, 0.1);
    outline: none;
  }
`;

export const Button = styled.button`
  padding: 1rem;
  background: #8b0000;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1.2rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;

  &:hover {
    background: #6b0000;
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    background: #e0e0e0;
    cursor: not-allowed;
    transform: none;
    color: #999;
  }
`;

export const ErrorText = styled.div`
  color: #8b0000;
  background: rgba(139, 0, 0, 0.05);
  padding: 0.8rem;
  border-radius: 8px;
  font-size: 0.9rem;
  border-left: 3px solid #8b0000;
  animation: ${fadeIn} 0.3s ease-out;
`;

export const SuccessText = styled.div`
  color: #2e7d32;
  background: rgba(46, 125, 50, 0.05);
  padding: 0.8rem;
  border-radius: 8px;
  font-size: 0.9rem;
  border-left: 3px solid #2e7d32;
  animation: ${fadeIn} 0.3s ease-out;
`;

export const LoadingSpinner = styled.div`
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top: 2px solid white;
  width: 16px;
  height: 16px;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;



// clock animation

export const ClockFace = styled.div`
  width: 200px;
  height: 200px;
  border-radius: 50%;
  background: linear-gradient(145deg, rgba(255,255,255,0.1), rgba(255,255,255,0.05));
  border: 10px solid rgba(255, 255, 255, 0.15);
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 
    0 4px 20px rgba(0, 0, 0, 0.25),
    inset 0 4px 15px rgba(0, 0, 0, 0.1),
    inset 0 -4px 15px rgba(0, 0, 0, 0.1);
  margin: 2rem auto;
  &::before {
    content: '';
    position: absolute;
    width: 94%;
    height: 94%;
    border-radius: 50%;
    border: 1px solid rgba(255,255,255,0.1);
  }
`;

export const ClockCenter = styled.div`
  width: 14px;
  height: 14px;
  background: #fff;
  border-radius: 50%;
  position: absolute;
  z-index: 10;
  box-shadow: 
    0 0 8px rgba(0, 0, 0, 0.4),
    inset 0 1px 2px rgba(255,255,255,0.2);
  &::after {
    content: '';
    position: absolute;
    width: 6px;
    height: 6px;
    background: #e32636;
    border-radius: 50%;
    top: 4px;
    left: 4px;
  }
`;

export const Hand = styled.div`
  position: absolute;
  bottom: 50%;
  left: 50%;
  transform-origin: 50% 100%;
  border-radius: 4px;
  filter: drop-shadow(0 1px 3px rgba(0, 0, 0, 0.3));
`;

export const HourHand = styled(Hand)`
  width: 6px;
  height: 60px;
  background: linear-gradient(to top, #fff, rgba(255,255,255,0.8));
  transform: translateX(-50%) rotate(${(props) => props.rotation}deg);
  border-radius: 6px 6px 3px 3px;
  z-index: 3;
  &::before {
    content: '';
    position: absolute;
    bottom: -4px;
    left: -2px;
    width: 10px;
    height: 10px;
    background: inherit;
    clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
  }
`;

export const MinuteHand = styled(Hand)`
  width: 4px;
  height: 82px;
  background: linear-gradient(to top, #fff, rgba(255,255,255,0.8));
  transform: translateX(-50%) rotate(${(props) => props.rotation}deg);
  border-radius: 4px 4px 2px 2px;
  z-index: 2;
`;

export const SecondHand = styled(Hand)`
  width: 2px;
  height: 88px;
  background: linear-gradient(to top, #e32636, #ff6b6b);
  transform: translateX(-50%) rotate(${(props) => props.rotation}deg);
  z-index: 1;
  &::after {
    content: '';
    position: absolute;
    bottom: -8px;
    left: -3px;
    width: 8px;
    height: 8px;
    background: #e32636;
    border-radius: 50%;
  }
`;

export const Tick = styled.div`
  position: absolute;
  width: ${props => props.hour ? '4px' : '2px'};
  height: ${props => props.hour ? '14px' : '8px'};
  background: ${props => props.hour ? '#fff' : 'rgba(255,255,255,0.7)'};
  transform-origin: 50% 100px;
  transform: translateX(-50%) rotate(${(props) => props.rotation}deg);
  border-radius: 2px;
`;
